"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CommandAddAdScoreSlide model module.
 * @module model/CommandAddAdScoreSlide
 * @version 1.1.3-alpha.1
 */
class CommandAddAdScoreSlide {
  /**
   * Constructs a new <code>CommandAddAdScoreSlide</code>.
   * @alias module:model/CommandAddAdScoreSlide
   * @param adscore_id {String} 
   * @param content_id {String} 
   */
  constructor(adscore_id, content_id) {
    CommandAddAdScoreSlide.initialize(this, adscore_id, content_id);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, adscore_id, content_id) {
    obj['adscore_id'] = adscore_id;
    obj['content_id'] = content_id;
  }

  /**
   * Constructs a <code>CommandAddAdScoreSlide</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CommandAddAdScoreSlide} obj Optional instance to populate.
   * @return {module:model/CommandAddAdScoreSlide} The populated <code>CommandAddAdScoreSlide</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CommandAddAdScoreSlide();
      if (data.hasOwnProperty('adscore_id')) {
        obj['adscore_id'] = _ApiClient.default.convertToType(data['adscore_id'], 'String');
      }
      if (data.hasOwnProperty('slide_number')) {
        obj['slide_number'] = _ApiClient.default.convertToType(data['slide_number'], 'Number');
      }
      if (data.hasOwnProperty('content_id')) {
        obj['content_id'] = _ApiClient.default.convertToType(data['content_id'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CommandAddAdScoreSlide</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommandAddAdScoreSlide</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of CommandAddAdScoreSlide.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['adscore_id'] && !(typeof data['adscore_id'] === 'string' || data['adscore_id'] instanceof String)) {
      throw new Error("Expected the field `adscore_id` to be a primitive type in the JSON string but got " + data['adscore_id']);
    }
    // ensure the json data is a string
    if (data['content_id'] && !(typeof data['content_id'] === 'string' || data['content_id'] instanceof String)) {
      throw new Error("Expected the field `content_id` to be a primitive type in the JSON string but got " + data['content_id']);
    }
    return true;
  }
}
CommandAddAdScoreSlide.RequiredProperties = ["adscore_id", "content_id"];

/**
 * @member {String} adscore_id
 */
CommandAddAdScoreSlide.prototype['adscore_id'] = undefined;

/**
 * @member {Number} slide_number
 */
CommandAddAdScoreSlide.prototype['slide_number'] = undefined;

/**
 * @member {String} content_id
 */
CommandAddAdScoreSlide.prototype['content_id'] = undefined;
var _default = CommandAddAdScoreSlide;
exports.default = _default;